module.exports = __webpack_public_path__ + "static/media/spw-global-high-quality-i.1cc58d2d.csv";